import { ButtonsI18n } from "@/locales/base.message.locales";

export const buttons: ButtonsI18n = {
  back: "VOLTAR",
  to_homepage: "Leve-me para a página inicial",
  go_to_site: "VISITAR O SITE",
  learn_more: "LEIA MAIS",
  solve_challenge: "Participe de desafios",
  post_challenge: "Enviar um desafio",
  solve_this_challenge: "RESOLVER ESTE DESAFIO",
  send: "ENVIAR",
  update: "ATUALIZAR",
  ok: "OK",
  cancel: "Cancelar",
  confirm: "Confirmar",
  follow: "SEGUIR",
  following: "SEGUINDO",
  share: "COMPARTILHAR",
  subscribe: "INSCREVER-SE",
  save: "Salvar",
  delete: "Remover",
  open_file: "Abrir arquivo",
  load_more: "Carregar mais",
  send_file: "Enviar Arquivo",
  create: "Criar",
  not_now: "Mais Tarde",
  see_more: "Ver mais"
};
